import { HexaInterestArea } from './SharedModels';

export interface Customer {
  id: number | string;
  name: string;
  odoo_id: string;
  active?: boolean;
  authorizations: string[];
  contract?: Contract;
  created: Date;
  modified: Date;
  interest_areas: HexaInterestArea[];
  api: boolean;
  business_base: boolean;
  fdr: boolean;
  infocamere: boolean;
  entity_events: boolean;
  translations_enabled: boolean;
  live_screening: boolean;
  live_dop: boolean;
  recap: boolean;
  search_full_evidences: boolean;
  search_full_associated_entities: boolean;
  expired_in: number;
}

export interface Contract {
  start_date: string | Date;
  end_date: string | Date;
  screening_quota: number;
  monitoring_quota: number;
  batch_screening_quota: number;
  total_screening_used?: number;
  remaining_screening_request?: number;
  total_monitoring_used?: number;
  remaining_monitoring_request?: number;
  total_batch_screening_used?: number;
  remaining_batch_screening_request?: number;
  flat: boolean;
  notes: string;
}

export const customerDefaultFormValues: Partial<Customer> = {
  name: '',
  id: '',
  odoo_id: '',
  active: false,
  interest_areas: new Array<HexaInterestArea>(),
  api: false,
  business_base: false,
  fdr: false,
  infocamere: false,
  entity_events: false,
  translations_enabled: false,
  live_screening: false,
  live_dop: false,
  recap: false,
  search_full_evidences: false,
  search_full_associated_entities: false,
  contract: {
    start_date: new Date(),
    end_date: new Date(),
    screening_quota: 0,
    monitoring_quota: 0,
    batch_screening_quota: 0,
    flat: false,
    notes: '',
  },
  expired_in: 0,
};
